<template>
  <div>
    <el-row type="flex" class="my-2">
      <el-col :span="24">
        <div class="text-center">
          <p>
            Reset password with required information
          </p>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex">
      <el-col :span="24">
        <el-form
          ref="form"
          :model="form"
          :rules="formRules"
          label-position="top"
        >
          <el-row type="flex" class="flex-wrap">
            <el-col :span="24">
              <el-form-item label="OTP" prop="otp" :rules="inputField()">
                <el-input
                  v-model="form.otp"
                  type="text"
                  required
                  @focus="changeColor($event)"
                  @blur="resetColor($event)"
                  v-only-number
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item label="Password" prop="password">
                <el-input
                  type="password"
                  v-model="form.password"
                  required
                  @focus="changeColor($event)"
                  @blur="resetColor($event)"
                  show-password
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item label="Confirm Password" prop="confirmPassword">
                <el-input
                  type="password"
                  v-model="form.confirmPassword"
                  required
                  @focus="changeColor($event)"
                  @blur="resetColor($event)"
                  show-password
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="24">
              <el-button
                class="authx-button w-100"
                :loading="resetting"
                type="primary"
                :disabled="preview"
                @click="resetPassword"
                >Reset</el-button
              >
              <el-button
                class="w-100"
                type="text"
                @click="$emit('navigate', 'login')"
              >
                <i class="ra-icon--chevron-left"></i> Back to login
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { currentUser } from "@/lib/utils";

export default {
  name: "NFormResetPassword",

  props: {
    token: {
      type: String,
      required: true
    },
    domainData: {
      type: Object,
      default() {
        return {};
      }
    },
    colors: {
      type: Object,
      default() {
        return {};
      }
    },

    validation: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    const validatePassword = (rule, value, callback) => {
      const {
        include_numbers,
        include_special,
        include_uppercase,
        min_length
      } = this.validation;

      let includeNumber, includeSpecial, includeUppercase;

      if (include_numbers) {
        const regex = new RegExp("^(?=.*[0-9]).+$");
        includeNumber = regex.test(value);
      }

      if (include_special) {
        const regex = new RegExp("^(?=.*[-+_!@#$%^&*., ?]).+$");
        includeSpecial = regex.test(value);
      }

      if (include_uppercase) {
        const uppercaseExp = new RegExp("^(?=.*[A-Z]).+$");
        includeUppercase = uppercaseExp.test(value);
      }

      if (value && include_numbers && !includeNumber) {
        callback(new Error("Use a number(e.g 1234)"));
      } else if (value && include_special && !includeSpecial) {
        callback(new Error("Use a symbol(e.g !@#$)"));
      } else if (value && include_uppercase && !includeUppercase) {
        callback(new Error("Use an uppercase letter(e.g ABC)"));
      } else if (value && value.min_length && value.length < min_length) {
        callback(new Error(`Use ${min_length} or more characters`));
      } else {
        callback();
      }
    };

    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error("Passwords don't match"));
      } else {
        callback();
      }
    };

    return {
      radiusUser: currentUser(),
      resetting: false,
      form: {
        otp: "",
        token: "",
        password: "",
        confirmPassword: ""
      },
      formRules: {
        password: [
          {
            required: true,
            message: "Enter new password",
            trigger: "change"
          },
          {
            validator: validatePassword,
            trigger: ["blur", "change"]
          }
        ],
        confirmPassword: [
          {
            required: true,
            message: "Confirm new password",
            trigger: "change"
          },
          {
            validator: validateConfirmPassword,
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },

  inject: ["preview"],

  computed: {
    preview() {
      return this.preview;
    }
  },

  created() {
    setTimeout(() => {
      this.setPrimaryColour();
    });
  },

  methods: {
    resetColor(evt) {
      evt.target.style.borderColor = "#dcdfe6";
    },

    changeColor(evt) {
      evt.target.style.borderColor = this.colors.secondary;
    },

    setPrimaryColour() {
      const primaryColor = `${this.colors.primary}`;

      const buttons = document.querySelectorAll(
        ".authx-button.el-button--primary"
      );
      buttons.forEach(button => {
        button.style.background = primaryColor;
        button.style.borderColor = primaryColor;
      });
    },

    resetPassword() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return false;
        }

        this.resetting = true;
        const body = {
          token: this.token,
          pin: this.form.otp,
          password: this.form.password
        };

        this.$http
          .post(
            "apps/password/verify",
            {
              body: body,
              method: "POST"
            },
            {
              headers: {
                "Session-Token": this.domainData.sessionToken
              }
            }
          )
          .then(response => {
            this.resetting = false;
            const { status } = response.data;
            if (status === "error") {
              this.handleErrors(response.data);
            } else {
              this.$emit("navigate", "login");
              this.notification(
                "Completed",
                "Password updated successfully",
                "success"
              );
            }
          })
          .catch(() => {
            this.resetting = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
